export default __webpack_public_path__ + "static/media/non4.5ad65636.png";